import axios from 'axios';

const apiTuig = axios.create({
    //Produção
    baseURL: 'https://inovegrupo.com.br:8085'
    // baseURL: 'http://inovegrupo.com.br:8086' //SEM SSL
    // baseURL: 'https://inovegrupo.com.br.ngrok.app'
    
    //Dev
    // baseURL: 'http://192.168.18.201:8085'
})

export default apiTuig;